document.addEventListener('mousedown', function(event) {
  const label = event.target.closest('.radios--value-button');

  if (!label) return;

  const radio = label.querySelector('.radios--input');

  if (!radio) return;

  const productOptions = label.closest('product-options-element');

  if (!productOptions) return;

  const currentProductUrl = productOptions.dataset.productUrl;
  const targetUrl = radio.dataset.productUrl;

  if (!currentProductUrl || !targetUrl) return;

  // Only the parent-page/default-option scenario
  if (radio.checked && currentProductUrl !== targetUrl) {
    event.preventDefault();
    window.location.assign(targetUrl);
  }
});